import React from 'react';
import { ChakraProvider } from '@chakra-ui/react'
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home';
import Questionnaire from './components/Questionnaire/Questionnaire';
import Login from './components/Dashboard/Login';
import Dashboard from './components/Dashboard/Home';
import Survey from './components/Dashboard/Survey';

function App() {
  return (
    <ChakraProvider>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/complete-survey/:token' element={<Questionnaire />}></Route>
        <Route path='/dashboard/login' element={<Login />}></Route>
        <Route path='/dashboard' element={<Dashboard />}></Route>
        <Route path='/dashboard/survey/:id' element={<Survey />}></Route>
      </Routes>
    </ChakraProvider>
  );
}

export default App;
